module.exports = __webpack_public_path__ + "img/exam.772348dd.png";